<template lang="pug">
div
  el-card.card-collapse(shadow="hover")
    div.cardHeader
      b Antecipação de Parcelas:
      el-button(
        type="primary"
        v-if="disableCheck.length > 0"
        @click="calcular"
      ) Calcular
    div#line
    tabela-amortizacao.margin(
      v-if="disableCheck.length > 0"
      :disableCheck="disableCheck"
      :isVisualizar="true",
      :dados="dadosAmortizacao"
      @parcelaAdicionada="parcelaAdicionada($event)"
    )
    app-display.padding(label="Data de vencimento da Antecipação/Quitação:", :content="dadosAntecipacao.dataVencimento" :contentAlignRight="true" :blackLabel="true" )
    app-display.padding(label="Total de parcelas a antecipar:", :content="qtdParcelas" :contentAlignRight="true" :blackLabel="true" )
    app-display.padding(label="Total a pagar:", :content="formatValor(valorTotal)" :contentAlignRight="true" :blackLabel="true" )

    app-buttons-cadastro(
      :showButtonSalvar='false',
      :showButtonCancelar='true',
      :showButtonFinalizar='true',
      :isUltimoPasso='true'
      :isPrimeiroPasso='true',
      :isIntroPasso='false',
      @cancelar='cancelar',
      @finalizar='finalizar'
    )
</template>

<script>
import { mapActions } from 'vuex'
import AppDivider from '@/components/AppDivider.vue'
import TabelaAmortizacao from '@/screens/analise/vtn/components/TabelaAmortizacao.vue'
import AppDisplay from '@/components/AppDisplay.vue'
import AppButtonsCadastro from '@/components/AppButtonsCadastro.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  components: {
    TabelaAmortizacao,
    AppDivider,
    AppDisplay,
    AppButtonsCadastro
  },

  props: {
    processo: {
      type: Object,
      required: true
    }
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      dadosAmortizacao: [],
      dadosAntecipacao: {
        dataVencimento: '',
        qtdParcelas: '',
        valorTotal: this.valorTotal
      },
      dadosVtn: this.$store.state.vtn.dadosVtn,
      disableCheck: [],
      parcelasSelecionadas: [],
      valorTotal: 0,
      qtdParcelas: 0
    }
  },

  async created () {
    const processo = await this.getProcesso(this.processo.numeroProtocolo)
    this.dadosVtn = await this.getVtnByIdProcesso(processo.id)
    this.dadosAmortizacao = this.dadosVtn.parcelasAp
    this.dadosAmortizacao.sort((p1, p2) => {
      if (p1.numero < p2.numero) {
        return -1
      } else {
        return 1
      }
    })

    this.dadosAmortizacao = this.dadosAmortizacao.filter((parcela) => {
      return parcela.status !== 'ADIANTADA' && parcela.status !== 'PAGA' && parcela.status !== 'NORMAL'
    })
    this.dadosAntecipacao.qtdParcelas = this.dadosVtn.qntdParcelas
    this.dadosAntecipacao.dataVencimento = this.dadosVtn.parcelasAp[0].dataVencimentoFormatada
    this.disableCheck = Array(this.dadosAmortizacao.length).fill(true)
    this.disableCheck[0] = false
    this.disableCheck[this.dadosAmortizacao.length - 1] = false
  },

  computed: {
    valorAntecipacao () {
      return this.valorTotal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
    }
  },

  methods: {
    ...mapActions({
      getProcesso: 'processos/getProcessoByProtocolo',
      getVtnByIdProcesso: 'vtn/getVtnbyIdProcesso',
      calcularAdiantamento: 'vtn/calcularAdiantamento',
      updateParcelas: 'vtn/updateParcelas'
    }),

    cancelar () {
      this.$router.push({
        name: 'gerenciamento-daes'
      })
    },

    async finalizar () {
      await this.calcular()
      const parcelasAtualizar = this.dadosVtn.parcelasAp.filter((parcela) => {
        return this.parcelasSelecionadas.parcelas.includes(parcela.numero)
      })
      parcelasAtualizar.forEach((parcela) => {
        parcela.status = 'ADIANTADA'
        parcela.vtn = {
          id: this.dadosVtn.id
        }
        if (parcela.boleto && parcela.boleto.dataEmissao) {
          const date = parcela.boleto.dataEmissao.split('/')
          const dataEmissao = [parseInt(date[2]), parseInt(date[1]), parseInt(date[0]), 1, 2, 3, 4]
          parcela.boleto.dataEmissao = dataEmissao
        }
      })

      await this.updateParcelas(parcelasAtualizar).then(() => {
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
          'Adiantamento requerido com sucesso.')

        this.cancelar()
      })
    },
    async calcular () {
      const adiantamentoRequest = {
        parcelas: this.parcelasSelecionadas.parcelas,
        idVtn: this.dadosVtn.id,
        isOrdemNormal: this.parcelasSelecionadas.ordem
      }
      this.valorTotal = await this.calcularAdiantamento(adiantamentoRequest)
      this.qtdParcelas = this.parcelasSelecionadas.length
    },
    parcelaAdicionada (parcelas) {
      this.parcelasSelecionadas = parcelas
    },
    formatValor (valor) {
      return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    }
  }
}
</script>

<style lang="scss" scoped>
  .card-collapse {
    border-radius: 10px;
    margin: 20px;
  }

  .margin {
    margin: 20px;
  }

  .margin-top {
    margin-top: 1%;
    margin: 20px;
  }

  #line {
    background-color: gainsboro;
    height: 2px;
    margin: 20px;
  }

  .cardHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px;
  }

  .padding {
    padding-left: 15px;
    padding-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/AntecipacaoParcela.vue